import {useAuth} from '@/contexts/auth-context'
import {permissions} from '@/lib/permissions'

export interface RelationshipSchemaPermissions {
    canView: boolean
    canManage: boolean
    canCreate: boolean
    canEdit: boolean
    canDelete: boolean
    canRunValidation: boolean
}

export function useRelationshipSchemaPermissions(): RelationshipSchemaPermissions {
    const {hasPermission} = useAuth()
    const canView = hasPermission(permissions.partyRelationshipSchema.view)
    const canManage = hasPermission(permissions.partyRelationshipSchema.manage)
    return {
        canView,
        canManage,
        canCreate: canManage,
        canEdit: canManage,
        canDelete: canManage,
        canRunValidation: canManage,
    }
}
